<app-new-banner></app-new-banner>
<new-flowbanner [showPromo]="true"></new-flowbanner>
<app-newstepper *ngIf='!isLoading' [activeStep]="1"></app-newstepper>

<div class="container" *ngIf="!isLoading && loaded">
  <h1 class="text-center message">
    Elige un plan que se adapte a tus <span>necesidades y presupuesto</span>
  </h1>

  <section class="row mt-5">
    <!-- Columna de izquierda con la información del plan -->
    <div class="col-md-7">
      <div class="plan">
        <label class="d-block mb-2 d-flex align-items-center justify-content-between">
          {{ res.planName }}
          <span class="badge-new">Nuevo</span>
        </label>
        <div class="d-flex left-content-between align-items-center">
          <label>${{ getTotal() | number:'1.0-0':'es-CO' }}</label>
          <span class="pago">/Pago único</span>
        </div>
        <div class="d-flex left-content-center mt-3 d-md-none">
          <img src="./assets/img/Line 1.png" alt="" />
          <img src="./assets/img/exclamacion.png" alt="Exclamación" />
          <small class="d-block text-message mt-2">
            El valor varía según el resultado del <br> análisis de tu inquilino y la duración del <br> contrato
          </small>
        </div>
        <p class="description d-md-none mt-3">
          <span class="font-weight-bold">La tarifa es flexible.</span> Ajusta
          las coberturas a tu medida.
        </p>

        <div class="accordion d-block d-md-none" id="accordionDetalle2">
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-heading2">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#flush-collapse2" aria-expanded="false" aria-controls="flush-collapse2">
                <p class="verDetalle">Ver detalles</p>
              </button>
            </h2>

            <div id="flush-collapse2" class="accordion-collapse collapse" aria-labelledby="flush-heading2"
              data-bs-parent="#accordionDetalle2">
              <div class="accordion-body">
                @for(coverage of res.coverages; track $index){
                @if(!coverage.isOptional){
                <div class="plan-item mb-3">
                  <div class="d-flex align-items-start">
                    <img src="./assets/img/cheque1.png" alt="Cheque de arrendamiento" class="mr-2 mb-2" />
                    <p><strong>{{ coverage.name }}:</strong> {{ coverage.detail }}</p>
                  </div>

                </div>
                }
                }

                <p class="included">Coberturas opcionales:</p>
                <form [formGroup]="myForm">
                  <ul class="list-unstyled">
                    @for(coverage of res.coverages; track $index){
                    @if(coverage.isOptional){
                    <li>
                      <label [for]="'check-mob-' + coverage.order" class="switch"
                        [ngClass]="{'active': myForm.get(coverage.order.toString())?.value}">
                        <input [formControlName]="coverage.order.toString()" class="d-none"
                          [id]="'check-mob-' + coverage.order" type="checkbox" />
                        <span class="slider"></span>
                      </label>
                      {{ coverage.name }}
                    </li>
                    }
                    }
                  </ul>
                </form>
                <p class="condicionado"> Ver el <a href="#" class="subrayado">condicionado</a> para mayor información
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4 text-center d-md-none">
          <button type="submit" class="btn btn-primary" (click)="comprar()" [disabled]="isClicked">Comprar</button>
        </div>
      </div>

      <div class="d-none d-md-flex left-content-center mt-3">
        <img src="./assets/img/Line 1.png" alt="" />
        <img src="./assets/img/exclamacion.png" alt="Exclamación" />
        <small class="d-block text-message mt-2">
          El valor varía según el análisis del inquilino y la duración del
          contrato
        </small>
      </div>

      <div class="mt-4 text-center d-none d-md-block">
        <button type="submit" class="btn btn-primary" (click)="comprar()" [disabled]="isClicked">Comprar</button>
      </div>

      <!-- Opciones de servicios -->
      <div class="mt-4 d-none d-md-block">
        <form [formGroup]="myForm">
          @for(coverage of res.coverages; track $index){
          @if(coverage.isOptional){
          <div class="service-item mb-4">
            <div class="d-flex align-items-center">
              <img src="./assets/img/cheque1.png" alt="Icono" class="mr-2" />
              <label [for]="'check-desk-' + coverage.order" class="service-title">{{ coverage.name }}</label>

              <div class="switch-container">
                <label [for]="'check-desk-' + coverage.order" class="switch"
                  [ngClass]="{'active': myForm.get(coverage.order.toString())?.value}">
                  <input [formControlName]="coverage.order.toString()" class="d-none"
                    [id]="'check-desk-' + coverage.order" type="checkbox" />
                </label>
              </div>
            </div>
            <div class="service-description">
              <p>{{ coverage.detail }}</p>
            </div>
          </div>
          }
          }
        </form>
      </div>
    </div>

    <!-- Columna de derecha con información adicional sobre qué incluye el plan -->
    <div class="col-md-5 d-none d-md-block">
      <h2 class="mb-4 small-title">Además, tu plan incluye</h2>

      @for(coverage of res.coverages; track $index){
      @if(!coverage.isOptional){
      <div class="plan-item">
        <div class="d-flex align-items-center">
          <img src="./assets/img/cheque1.png" alt="Cheque de arrendamiento" class="mr-2 mb-2" />
          <h3>{{ coverage.name }}</h3>
        </div>
        <p>{{ coverage.detail }}</p>
      </div>
      }
      }
    </div>
  </section>
</div>

<app-footer-app></app-footer-app>
<app-help-to-call></app-help-to-call>